export default {
  TOGGLE_LOADING: 'TOGGLE_LOADING',
  TOGGLE_SIDEBAR: 'TOGGLE_SIDEBAR',
  SET_PERMISSIONS: 'SET_PERMISSIONS',
  FETCH_FIELD_DEFINITIONS: 'FETCH_FIELD_DEFINITIONS',
  TOGGLE_MOBILE_SIDEBAR: 'TOGGLE_MOBILE_SIDEBAR',
  SET_GLOBAL_ALERT: 'SET_GLOBAL_ALERT',
  SET_ERROR: 'SET_ERROR',
  CLEAR_ERROR: 'CLEAR_ERROR',
  LAUNCH_ALERT: 'LAUNCH_ALERT',
  GET_HELP_URL: 'GET_HELP_URL',
  SET_HELP_URL: 'SET_HELP_URL',
  FETCH_API_VERSION: 'FETCH_API_VERSION'
}
